/**
 * tasksense-capability-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScheduleAction { 
    scheduleId?: string;
    action?: ScheduleAction.ActionEnum;
}
export namespace ScheduleAction {
    export const ActionEnum = {
        Deactivate: 'DEACTIVATE',
        Delete: 'DELETE'
    } as const;
    export type ActionEnum = typeof ActionEnum[keyof typeof ActionEnum];
}


